import { WEB_ASSETS, type SettingsGroup, type SettingsPage } from '@tenfour/contracts';
import { DestinationTile, type DestinationTone } from './DestinationTile';

/** Settings groups wear the rail's tones: each group's colour sits on the tile. */
const GROUP_TONES: Record<SettingsGroup, DestinationTone> = {
  'day-to-day': 'day',
  'reaching-customers': 'reach',
  'your-business': 'business',
  'plan-and-access': 'plan',
};

/** The same filled art, pigment, and tile wash used by the settings rail. */
export function SettingsIcon({ page }: { page: SettingsPage }) {
  const src = WEB_ASSETS.icons.settingsDestinations[page.id as keyof typeof WEB_ASSETS.icons.settingsDestinations];
  if (!src) return null;
  return <DestinationTile src={src} tone={GROUP_TONES[page.group]} />;
}
